import flow from 'lodash/flow';
import { connect } from 'react-redux';
import { submitFromCapacityWaitlistTicketsPage } from '../../actions/order/common';
import { getEventCapacityWaitlistTicketsPageCtaText } from '../../selectors/tickets';
import { connectTicketSelectionPage } from './connectTicketSelectionPage';
import TicketSelectionFullSizePage from './TicketSelectionFullSizePage';
import { notifyParentJoinWaitlist } from '../../actions/notifyParent';

const _getFooterProps = (state) => ({
    ctaText: getEventCapacityWaitlistTicketsPageCtaText(state),
    isDisabled: false,
});

const _mapStateToProps = (state) => ({
    ..._getFooterProps(state),
});

export const _mapDispatchToProps = (dispatch) => ({
    onSubmit: () => {
        dispatch(notifyParentJoinWaitlist());
        dispatch(submitFromCapacityWaitlistTicketsPage());
    },
});

/**
 * This uses TicketSelectionFullSizePage and connectTicketSelectionPage, but just overrides the few values
 * we need to be specific to the waitlist as defined above.
 */
export const connectEventCapacityWaitlistTicketsPage = () =>
    flow(
        connect(_mapStateToProps, _mapDispatchToProps),
        connectTicketSelectionPage,
    )(TicketSelectionFullSizePage);
